/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProjectDomainAuditRowData } from './ProjectDomainAuditRowData';
import {
    ProjectDomainAuditRowDataFromJSON,
    ProjectDomainAuditRowDataFromJSONTyped,
    ProjectDomainAuditRowDataToJSON,
    ProjectDomainAuditRowDataToJSONTyped,
} from './ProjectDomainAuditRowData';

/**
 * 
 * @export
 * @interface ProjectDomainAuditData
 */
export interface ProjectDomainAuditData {
    /**
     * 
     * @type {number}
     * @memberof ProjectDomainAuditData
     */
    fallbackCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ProjectDomainAuditData
     */
    createdCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ProjectDomainAuditData
     */
    unresolvedCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ProjectDomainAuditData
     */
    knownHostCount?: number;
    /**
     * 
     * @type {Array<ProjectDomainAuditRowData>}
     * @memberof ProjectDomainAuditData
     */
    rows?: Array<ProjectDomainAuditRowData>;
}

/**
 * Check if a given object implements the ProjectDomainAuditData interface.
 */
export function instanceOfProjectDomainAuditData(value: object): value is ProjectDomainAuditData {
    return true;
}

export function ProjectDomainAuditDataFromJSON(json: any): ProjectDomainAuditData {
    return ProjectDomainAuditDataFromJSONTyped(json, false);
}

export function ProjectDomainAuditDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectDomainAuditData {
    if (json == null) {
        return json;
    }
    return {
        
        'fallbackCount': json['fallbackCount'] == null ? undefined : json['fallbackCount'],
        'createdCount': json['createdCount'] == null ? undefined : json['createdCount'],
        'unresolvedCount': json['unresolvedCount'] == null ? undefined : json['unresolvedCount'],
        'knownHostCount': json['knownHostCount'] == null ? undefined : json['knownHostCount'],
        'rows': json['rows'] == null ? undefined : ((json['rows'] as Array<any>).map(ProjectDomainAuditRowDataFromJSON)),
    };
}

export function ProjectDomainAuditDataToJSON(json: any): ProjectDomainAuditData {
    return ProjectDomainAuditDataToJSONTyped(json, false);
}

export function ProjectDomainAuditDataToJSONTyped(value?: ProjectDomainAuditData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fallbackCount': value['fallbackCount'],
        'createdCount': value['createdCount'],
        'unresolvedCount': value['unresolvedCount'],
        'knownHostCount': value['knownHostCount'],
        'rows': value['rows'] == null ? undefined : ((value['rows'] as Array<any>).map(ProjectDomainAuditRowDataToJSON)),
    };
}

